import React, { useEffect, useState } from 'react';
import { ScheduleComponent, Day, Week, WorkWeek, Month, Inject } from '@syncfusion/ej2-react-schedule';
import { registerLicense } from '@syncfusion/ej2-base';
import './TimeTableLibrary.css';
// Paste your license key inside the string below
registerLicense('ORg4AjUWIQA/Gnt2XFhhQlJHfVhdWHxLflFzVWBTfV56dFdWACFaRnZdR11lSXtSc0dkWH5bcn1cTWJV');

// Optional: Custom styling for events
const onEventRendered = (args) => {
    const eventColor = args.data.CategoryColor || '#FF52C5';
    args.element.style.backgroundColor = eventColor;
    args.element.style.borderRadius = '8px';
    args.element.style.color = 'white';
  };

const SchedulerView = ({instituteClasses, activeType, setCombinedEvents, setFinalDrivingClassesSchedule,
  setFinalInClassClassesSchedule, setFinalOnlineClassesSchedule, finalDrivingClassesSchedule,
  finalInClassClassesSchedule, finalOnlineClassesSchedule, setAddClassEvents, addClassEvents,
  setFinalClassesSchedule, StudentAllCoursesSchedule, allInstructorsScheduledClasses, setError,
  CoursePackage, setShowWeeklyAddClassPopup, setShowCustomTimeTableLibraryAddPopup, setPendingNewEvent, finalClassesSchedule}) => {
  console.log("instituteClasses in the show schedule is:",instituteClasses)
  console.log("addClassEvents in the show schedule is:",addClassEvents)

  const eventTemplate = (props) => {
    return (
      <div style={{ padding: '4px' }}>
        <div><strong>{props.Subject}</strong></div>
            {/* {props.InstructorName && <div>Instructor: {props.InstructorName}</div>} */}
            {props.StudentName && <div>{props.StudentName}</div>}
            {props.InstructorName && <div>{props.InstructorName}</div>}

            {props.StartTime && (
                <div>
                    {props.StartTime.toLocaleTimeString()} - {props.EndTime.toLocaleTimeString()}
                </div>
            )}
      </div>
    );
  };

  const handleActionBegin = (args) => {
    console.log("args is:", args);
    console.log(">>> actionBegin triggered:", args);

    const event = args.data;

    let sourceType = null;
    if (Array.isArray(event) && event.length > 0) {
      sourceType = event[0]?.sourceType;
    } else if (event && typeof event === 'object') {
      sourceType = event.sourceType;
    }
    
    console.log(">>> sourceType triggered:", sourceType);

    // ❌ Prevent editing/removing if event is from studentSchedule or instituteClasses
    if (sourceType === 'studentSelectedSchedule' || sourceType === 'instructor') {
      args.cancel = true;
      setError("You cannot edit or delete this class.");
      setTimeout(() => setError(''), 10000);
      return;
    }

     // 🔧 Utility to normalize and overwrite only time-related fields
    const normalizeUpdatedTimes = (event) => {
      const newStart = new Date(event.StartTime || event.startDate || event.start);
      const newEnd = new Date(event.EndTime || event.endDate || event.end);
      return {
        StartTime: newStart,
        EndTime: newEnd,
        startDate: newStart,
        endDate: newEnd,
        start: newStart.toISOString(),
        end: newEnd.toISOString(),
      };
    };
  
    if (args.requestType === 'eventRemove') {
      const deletedEvent = args.data[0];
      const deletedId = deletedEvent.event_id;
      console.log("deletedId is:", deletedId);
  
      // 1. Remove from combined events
      setCombinedEvents(prev =>
        prev.filter(e =>
          (e.event_id) !== deletedId
        )
      );
      setAddClassEvents(prev =>
        prev.filter(e =>
          (e.event_id) !== deletedId
        )
      );
      setFinalClassesSchedule(prev =>
        prev.filter(e =>
          (e.event_id) !== deletedId
        )
      );
      
      // 2. Remove from category-specific list
      const subject = deletedEvent.Subject || '';
      if (subject.includes("Driving")) {
        setFinalDrivingClassesSchedule(prev =>
          prev.filter(e => (e.event_id) !== deletedId)
        );
      } else if (subject.includes("InClass")) {
        setFinalInClassClassesSchedule(prev =>
          prev.filter(e => (e.event_id) !== deletedId)
        );
      } else if (subject.includes("Online")) {
        setFinalOnlineClassesSchedule(prev =>
          prev.filter(e => (e.event_id) !== deletedId)
        );
      }
    }
  
    if (args.requestType === 'eventChange') {
      const updated = args.data;
      const updatedId = updated.event_id;
  
      const newStart = new Date(updated.StartTime || updated.startDate);
      const newEnd = new Date(updated.EndTime || updated.endDate);
      const classType = updated.ClassType;
  
      const instructorId = updated.Instructors || updated.InstructorFK;
      const formattedDate = newStart.toLocaleDateString('en-US');
  
      const overlaps = (aStart, aEnd, bStart, bEnd) =>
        aStart < bEnd && bStart < aEnd;
  
      const studentSchedule = StudentAllCoursesSchedule.map(item => ({
        start: new Date(item.startDate || item.StartTime),
        end: new Date(item.endDate || item.EndTime),
      }));
  
      const instructorSchedule = allInstructorsScheduledClasses
        .filter(item =>
          (item.InstructorId === instructorId || item.InstructorFK === instructorId) &&
          (item.event_id) !== updatedId
        )
        .map(item => ({
          start: new Date(item.startDate || item.StartTime),
          end: new Date(item.endDate || item.EndTime),
        }));
  
      const studentConflict = studentSchedule.find(existing =>
        overlaps(newStart, newEnd, existing.start, existing.end)
      );
      if (studentConflict) {
        const overlapStart = new Date(Math.max(newStart, studentConflict.start));
        const overlapEnd = new Date(Math.min(newEnd, studentConflict.end));
        const conflictTime = `${overlapStart.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${overlapEnd.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
        setError(`Student already has a class on ${formattedDate} at ${conflictTime}`);
        setTimeout(() => setError(''), 5000);
        return;
      }
  
      const instructorConflict = instructorSchedule.find(existing =>
        overlaps(newStart, newEnd, existing.start, existing.end)
      );
      if (instructorConflict) {
        const overlapStart = new Date(Math.max(newStart, instructorConflict.start));
        const overlapEnd = new Date(Math.min(newEnd, instructorConflict.end));
        const conflictTime = `${overlapStart.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${overlapEnd.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
        setError(`Instructor already has a class on ${formattedDate} at ${conflictTime}`);
        setTimeout(() => setError(''), 5000);
        return;
      }

      // ❌ Conflict with other classes of the same course (Driving, InClass, Online, addClassEvents)
      const courseSchedule = [
        ...addClassEvents,
        ...finalDrivingClassesSchedule,
        ...finalOnlineClassesSchedule,
        ...finalInClassClassesSchedule,
      ].filter(event => (event.event_id || event.Id) !== updatedId); // ✅ exclude current being updated

      const newDate = newStart.toDateString();

      const courseConflict = courseSchedule.find(existing => {
        const existingStart = new Date(existing.startDate || existing.StartTime);
        const existingEnd = new Date(existing.endDate || existing.EndTime);
        const existingDate = existingStart.toDateString();

        return existingDate === newDate && overlaps(newStart, newEnd, existingStart, existingEnd);
      });

      if (courseConflict) {
        const overlapStart = new Date(Math.max(newStart, new Date(courseConflict.startDate || courseConflict.StartTime).getTime()));
        const overlapEnd = new Date(Math.min(newEnd, new Date(courseConflict.endDate || courseConflict.EndTime).getTime()));

        const conflictTime = `${overlapStart.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${overlapEnd.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
        const conflictDate = overlapStart.toLocaleDateString('en-US');

        setError(`A class for this course already exists on ${conflictDate} at ${conflictTime}.`);
        setTimeout(() => setError(''), 5000);
        return;
      }

      const getTotalHours = (classes) =>
        classes.reduce((sum, cls) => {
          const start = new Date(cls.StartTime || cls.startDate);
          const end = new Date(cls.EndTime || cls.endDate);
          return sum + (end - start) / (1000 * 60 * 60);
        }, 0);
  
      const getCombinedScheduleByType = () => {
        const finalSchedule =
          classType === "Driving"
            ? finalDrivingClassesSchedule
            : classType === "Online"
            ? finalOnlineClassesSchedule
            : classType === "InClass"
            ? finalInClassClassesSchedule
            : [];
  
        const pendingSchedule = addClassEvents.filter(e => e.ClassType === classType);
  
        return [...finalSchedule, ...pendingSchedule];
      };
  
      const combinedSchedule = getCombinedScheduleByType().filter(
        cls => (cls.event_id) !== updatedId
      );
  
      const updatedDuration = (newEnd - newStart) / (1000 * 60 * 60);
      const totalScheduled = getTotalHours(combinedSchedule);
      const totalAllowed = CoursePackage?.[`${classType}Hours`] || 0;
  
      if (totalScheduled + updatedDuration > totalAllowed) {
        setError(`Cannot update. Total allowed ${classType} hours (${totalAllowed}) will be exceeded.`);
        setTimeout(() => setError(''), 5000);
        return;
      }
  
      // 🔁 Normalized updated time fields
      const updatedTimes = normalizeUpdatedTimes(updated);
  
      setCombinedEvents(prev =>
        prev.map(e =>
          e.event_id === updatedId ? { ...e, ...updatedTimes } : e
        )
      );
      setAddClassEvents(prev =>
        prev.map(e =>
          e.event_id === updatedId ? { ...e, ...updatedTimes } : e
        )
      );
      setFinalClassesSchedule(prev =>
        prev.map(e =>
          e.event_id === updatedId ? { ...e, ...updatedTimes } : e
        )
      );
  
      if (classType === "Driving") {
        setFinalDrivingClassesSchedule(prev =>
          prev.map(e =>
            e.event_id === updatedId ? { ...e, ...updatedTimes } : e
          )
        );
      } else if (classType === "InClass") {
        setFinalInClassClassesSchedule(prev =>
          prev.map(e =>
            e.event_id === updatedId ? { ...e, ...updatedTimes } : e
          )
        );
      } else if (classType === "Online") {
        setFinalOnlineClassesSchedule(prev =>
          prev.map(e =>
            e.event_id === updatedId ? { ...e, ...updatedTimes } : e
          )
        );
      }
    }

    // if (args.requestType === 'eventCreate') {
    //   args.cancel = true; // ⛔ cancel default popup
    //   const newEvent = args.data[0]; // assuming single event
    //   console.log("eventCreate in")
    
    //   setPendingNewEvent(newEvent); // Store this in state to edit
    //   // setShowCustomAddPopup(true);  // Your modal visibility state
    //   setShowWeeklyAddClassPopup(true);

    // }
    
    
  };
  
  return (
    <div className="custom-scheduler-scope">
      <ScheduleComponent
        timeFormat="hh:mm a"
        eventSettings={{
            dataSource: instituteClasses,
            template: eventTemplate,
            allowEditing: true,
            allowDeleting: true,
            allowAdding: true, 
        }}
        eventRendered={onEventRendered}
        actionBegin={handleActionBegin}
        popupOpen={(args) => {
          // Prevent QuickInfo popup if sourceType is restricted
          // if (args.type === 'QuickInfo') {
          //   args.cancel = true;
          //   return;
          // }
          // if (args.type === 'QuickInfo') {
          //   const event = args.data;

          //   let sourceType = null;
          //   if (Array.isArray(event) && event.length > 0) {
          //     sourceType = event[0]?.sourceType;
          //   } else if (event && typeof event === 'object') {
          //     sourceType = event.sourceType;
          //   }

          //   if (sourceType === 'studentSelectedSchedule' || sourceType === 'instructor') {
          //     args.cancel = true;
          //     return;
          //   }
          // }
          const event = args.data;

          // Extract sourceType from the event
          let sourceType = null;
          if (Array.isArray(event) && event.length > 0) {
            sourceType = event[0]?.sourceType;
          } else if (event && typeof event === 'object') {
            sourceType = event.sourceType;
          }

          // ✅ Block popups only for existing events with non-addClass sourceType
          if (sourceType && sourceType !== 'addClass') {
            args.cancel = true;
            return;
          }

           // 🔒 Handle QuickInfo (single-click)
          if (args.type === 'QuickInfo') {
            // 🔒 If no event (i.e., empty cell) OR event sourceType is not 'addClass' → cancel popup
            if (!sourceType || sourceType !== 'addClass') {
              args.cancel = true;
              return;
            }
          }

          if (args.type === 'Editor' && !args.data.Guid) {
            // Check if there are NO events in both final and add class schedule
            if (finalClassesSchedule.length === 0) {
              setError("You must first add or confirm at least one class to open this popup.");
              setTimeout(() => setError(''), 5000);
              args.cancel = true;
              return;
            }

            args.cancel = true; // ✅ Cancel default editor popup

            const rawStart = args.data?.StartTime;
            const rawEnd = args.data?.EndTime;

            // Validate input
            if (!rawStart || !rawEnd) {
              console.warn("ScheduleComponent: Invalid start or end time in args:", args);
              setError("Could not read selected time from calendar.");
              setTimeout(() => setError(''), 5000);
              return;
            }

            const start = new Date(rawStart);
            const end = new Date(rawEnd);

            if (isNaN(start) || isNaN(end)) {
              console.warn("ScheduleComponent: Invalid date object created from start/end time:", { rawStart, rawEnd });
              setError("Invalid date/time selected.");
              setTimeout(() => setError(''), 5000);
              return;
            }

            const newEvent = {
              StartTime: start,
              EndTime: end,
              startDate: start,
              endDate: end,
            };

            setPendingNewEvent(newEvent); // Pass time range
            setShowCustomTimeTableLibraryAddPopup(true); // Show your popup
          }
        }}
        currentView="Week"
      >
        <Inject services={[Day, Week, WorkWeek, Month]} />
      </ScheduleComponent>
    </div>
  );
};

export default SchedulerView;


   // if (args.requestType === 'eventChange') {
    //   const updated = args.data;
    //   const updatedId = updated.event_id;
    //   console.log("updated is:", updated);
  
    //   setCombinedEvents(prev =>
    //     prev.map(e => (e.Id || e.event_id) === updatedId ? { ...e, ...updated } : e)
    //   );
    //   setAddClassEvents(prev =>
    //     prev.map(e => (e.Id || e.event_id) === updatedId ? { ...e, ...updated } : e)
    //   );
    //   // setFinalClassesSchedule(prev =>
    //   //   prev.map(e => (e.Id || e.event_id) === updatedId ? { ...e, ...updated } : e)
    //   // );
  
    //   const subject = updated.Subject || '';
    //   if (subject.includes("Driving")) {
    //     setFinalDrivingClassesSchedule(prev =>
    //       prev.map(e => (e.Id || e.event_id) === updatedId ? { ...e, ...updated } : e)
    //     );
    //   } else if (subject.includes("InClass")) {
    //     setFinalInClassClassesSchedule(prev =>
    //       prev.map(e => (e.Id || e.event_id) === updatedId ? { ...e, ...updated } : e)
    //     );
    //   } else if (subject.includes("Online")) {
    //     setFinalOnlineClassesSchedule(prev =>
    //       prev.map(e => (e.Id || e.event_id) === updatedId ? { ...e, ...updated } : e)
    //     );
    //   }
    // }




     // if (args.requestType === 'eventChange') {
    //   const updated = args.data;
    //   const updatedId = updated.event_id;
    //   console.log("updated is:", updated);
    
    //   const newStart = new Date(updated.StartTime || updated.startDate);
    //   const newEnd = new Date(updated.EndTime || updated.endDate);
    //   const classType = updated.ClassType;
    
    //   const instructorId = updated.Instructors || updated.InstructorFK;
    //   const formattedDate = newStart.toLocaleDateString('en-US');
    
    //   const overlaps = (aStart, aEnd, bStart, bEnd) =>
    //     aStart < bEnd && bStart < aEnd;
    
    //   // 1. Get Student Schedule
    //   const studentSchedule = StudentAllCoursesSchedule.map(item => ({
    //     start: new Date(item.startDate || item.StartTime),
    //     end: new Date(item.endDate || item.EndTime),
    //   }));
    
    //   // 2. Get Instructor Schedule (excluding this class itself)
    //   const instructorSchedule = allInstructorsScheduledClasses
    //     .filter(item =>
    //       (item.InstructorId === instructorId || item.InstructorFK === instructorId) &&
    //       (item.event_id || item.Id) !== updatedId
    //     )
    //     .map(item => ({
    //       start: new Date(item.startDate || item.StartTime),
    //       end: new Date(item.endDate || item.EndTime),
    //     }));
    
    //   // 3. Conflict: Student
    //   const studentConflict = studentSchedule.find(existing =>
    //     overlaps(newStart, newEnd, existing.start, existing.end)
    //   );
    //   if (studentConflict) {
    //     const overlapStart = new Date(Math.max(newStart, studentConflict.start));
    //     const overlapEnd = new Date(Math.min(newEnd, studentConflict.end));
    //     const conflictTime = `${overlapStart.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${overlapEnd.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
    
    //     setError(`❌ Student already has a class on ${formattedDate} at ${conflictTime}`);
    //     setTimeout(() => setError(''), 5000);
    //     return;
    //   }
    
    //   // 4. Conflict: Instructor
    //   const instructorConflict = instructorSchedule.find(existing =>
    //     overlaps(newStart, newEnd, existing.start, existing.end)
    //   );
    //   if (instructorConflict) {
    //     const overlapStart = new Date(Math.max(newStart, instructorConflict.start));
    //     const overlapEnd = new Date(Math.min(newEnd, instructorConflict.end));
    //     const conflictTime = `${overlapStart.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${overlapEnd.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
    
    //     setError(`❌ Instructor already has a class on ${formattedDate} at ${conflictTime}`);
    //     setTimeout(() => setError(''), 5000);
    //     return;
    //   }
    
    //   // 5. Hour Limit Check
    //   const getTotalHours = (classes) =>
    //     classes.reduce((sum, cls) => {
    //       const start = new Date(cls.StartTime || cls.startDate);
    //       const end = new Date(cls.EndTime || cls.endDate);
    //       return sum + (end - start) / (1000 * 60 * 60);
    //     }, 0);
    
    //   // const getFinalScheduleByType = () => {
    //   //   if (classType === "Driving") return finalDrivingClassesSchedule;
    //   //   if (classType === "Online") return finalOnlineClassesSchedule;
    //   //   if (classType === "InClass") return finalInClassClassesSchedule;
    //   //   return [];
    //   // };

    //   // Combine final and pending classes
    //   const getCombinedScheduleByType = () => {
    //     const finalSchedule =
    //       classType === "Driving"
    //         ? finalDrivingClassesSchedule
    //         : classType === "Online"
    //         ? finalOnlineClassesSchedule
    //         : classType === "InClass"
    //         ? finalInClassClassesSchedule
    //         : [];

    //     const pendingSchedule = addClassEvents.filter(e => e.ClassType === classType);

    //     return [...finalSchedule, ...pendingSchedule];
    //   };
    
    //   // Filter out the class being edited
    //   const combinedSchedule = getCombinedScheduleByType().filter(
    //     cls => (cls.Id || cls.event_id) !== updatedId
    //   );

    //   const updatedDuration = (newEnd - newStart) / (1000 * 60 * 60);
    //   const totalScheduled = getTotalHours(combinedSchedule);
    //   const totalAllowed = CoursePackage?.[`${classType}Hours`] || 0;

    //   if (totalScheduled + updatedDuration > totalAllowed) {
    //     setError(`⛔ Cannot update. Total allowed ${classType} hours (${totalAllowed}) will be exceeded.`);
    //     setTimeout(() => setError(''), 5000);
    //     return;
    //   }
    
    //   // ✅ If all checks pass - perform the updates
    //   setCombinedEvents(prev =>
    //     prev.map(e => (e.event_id) === updatedId ? { ...e, ...updated } : e)
    //   );
    //   setAddClassEvents(prev =>
    //     prev.map(e => (e.event_id) === updatedId ? { ...e, ...updated } : e)
    //   );
    //   setFinalClassesSchedule(prev =>
    //     prev.map(e => (e.event_id) === updatedId ? { ...e, ...updated } : e)
    //   );
    //   console.log("classType is:", classType);

    //   if (classType === "Driving") {
    //     setFinalDrivingClassesSchedule(prev =>
    //       prev.map(e => (e.event_id) === updatedId ? { ...e, ...updated } : e)
    //     );
    //   } else if (classType === "InClass") {
    //     setFinalInClassClassesSchedule(prev =>
    //       prev.map(e => (e.event_id) === updatedId ? { ...e, ...updated } : e)
    //     );
    //   } else if (classType === "Online") {
    //     setFinalOnlineClassesSchedule(prev =>
    //       prev.map(e => (e.event_id) === updatedId ? { ...e, ...updated } : e)
    //     );
    //   }
    // }

